import Vue from 'vue'
import App from './App.vue'
import zTable from '@common/components/z-table/fixed-table'
import zCell from '@common/components/z-table/align-cell'
import commonSvg from '@common/components/commonSvg'

import './plugins/element.js'
import '../theme/index.css'
import './style/common.scss'

import './js/http.js'
import commonUtils from '@common/js/utils'
import utils from './js/utils.js'
import store from './vuex/store'
import Vuex from 'vuex'
import VueHighlightJS from '@lib/highlight'
import VueClipboard from 'vue-clipboard2'
import router from './router'
import '../static/font/y-icon.js'
import waterfall from 'vue-waterfall2'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.component('zTable', zTable)
Vue.component('zCell', zCell)
Vue.component('commonSvg', commonSvg)
Vue.use(commonUtils)
Vue.use(waterfall)
Vue.use(utils)
Vue.use(Vuex)
Vue.use(VueHighlightJS)
Vue.use(VueClipboard)
Vue.use(VueLazyload)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
